import {z} from '@hono/zod-openapi';

/** The VIN in the path of the standalone decoder operation. */
export const priceReportVinParamSchema = z.object({vin: z.string()});
